import { render, staticRenderFns } from "./langtest_check.vue?vue&type=template&id=2481a0a2&scoped=true&"
import script from "./langtest_check.vue?vue&type=script&lang=js&"
export * from "./langtest_check.vue?vue&type=script&lang=js&"
import style0 from "./langtest_check.vue?vue&type=style&index=0&id=2481a0a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481a0a2",
  null
  
)

export default component.exports